/**
 * `stat_changes` reaches the client as a list of `{ stat, value }` rows — the
 * OpenAPI schema types it `string`, but `ModificatorSerializer.get_stat_changes`
 * returns the list — and interpolating it straight into a template printed the
 * serialized JSON at the player. Every other shape (absent, empty, a bare
 * string, a row missing its value) degrades to no rows rather than to
 * punctuation.
 */
export interface StatDelta {
  key: string
  stat: string
  /** A typographic minus, not a hyphen: it aligns with `+` in the mono readout. */
  sign: '+' | '−'
  magnitude: number
  positive: boolean
}

export const statDeltasOf = (changes: unknown): StatDelta[] => {
  if (!Array.isArray(changes)) return []
  return changes.flatMap((change: any, index: number) => {
    const stat = typeof change?.stat === 'string' ? change.stat.trim() : ''
    const value = Number(change?.value)
    if (!stat || !Number.isFinite(value) || value === 0) return []
    return [{
      key: `${stat}-${index}`,
      stat,
      sign: value > 0 ? '+' : '−',
      magnitude: Math.abs(value),
      positive: value > 0,
    } as StatDelta]
  })
}
